export const MODULE_BACK_PATH = 'parking-meters';

export const PARKING_METER_STATUS = {
  ERROR: -99,
  WARNING: -1,
  OK: 1,
};

export const PARKING_METER_AVAILABLE_STATUS = {
  ERROR: -99,
  WARNING: -1,
  OK: 1,
};

export const PRINTER_STATE = {
  ERROR: -99,
  PAPER_JAMMED: -3,
  PAPER_EMPTY: -2,
  PAPER_LOW: -1,
  UNKNOWN: 0,
  OK: 1,
};

export const PARKING_SERVER_STATE = {
  ERROR: -99,
  UNREGISTERED: -1,
  UNKNOWN: 0,
  OK: 1,
};

export const DOOR_LOCK_STATE = {
  ERROR: -99,
  UNKNOWN: 0,
  LOCKED: 1,
  UNLOCKED_CLOSED: 2,
  UNLOCKED_OPENED: 3,

};

export const DOOR_STATE = {
  UNKNOWN: 0,
  OPENED: 1,
  CLOSED: 2,
};

export const BANK_STATE = {
  ERROR: '-1',
  UNKNOWN: '0',
  OK: '1',
};

export const PAYMENT_CONTROLLER_STATE = {
  ERROR: -99,
  UNKNOWN: 0,
  IDLE: 1,
  WAIT_CARD: 2,
  WAIT_BANK: 3,
  COMPLETE: 4,
};

export const APP_STATE = {
  ERROR: -99,
  UNKNOWN: 0,
  IDLE: 1,
  USER_CHOICE: 2,
  PAYMENT: 3,
  PRINT_RECEIPT: 4,
  SERVICE: 5,
};

export const POWER_SUPPLY = {
  PERMANENT: 1,
  BATTERY_1: 2,
  BATTERY_2: 3,
  BOTH: 4,
};
export const POWER_STATE = {
  ERROR: -99,
  LOW_POWER: -1,
  UNKNOWN: 0,
  OK: 1,
};
export const pmMetricKeys = [
  'APP_STATE',
  'STATE',
];
export const printerMetricKeys = [
  'PRINTER_STATE',
];
export const lockMetricKeys = [
  'DOOR_LOWER_LOCK_STATE',
  'DOOR_UPPER_LOCK_STATE',
];
export const doorMetricKeys = [
  'DOOR_LOWER_STATE',
  'DOOR_UPPER_STATE',
];
export const psMetricKeys = [
  'PARKING_SERVER_STATE',
];
export const payMetricKeys = [
  'PAYMENT_CONTROLLER_STATE',
];
export const bankMetricKeys = [
  'BANK_STATE',
];

export const pwrMetricKeys = [
  'POWER_STATE',
  'POWER_SUPPLY',
  'POWER_CHARGE_BUS',
  'POWER_BUS',
  'POWER_BATTERY_1',
  'POWER_BATTERY_2',
];
export const metricKeys = [
  ...pmMetricKeys,
  ...printerMetricKeys,
  ...lockMetricKeys,
  ...doorMetricKeys,
  ...psMetricKeys,
  ...pwrMetricKeys,
  ...payMetricKeys,
  ...bankMetricKeys,
];

export const PARKING_METER_COMMAND = {
  DEVICE_REBOOT: 'DEVICE_REBOOT',
  DOORLOWER_OPEN: 'UNLOCK_LOWERLOCK',
  DOORUPPER_OPEN: 'UNLOCK_UPPERLOCK',
  SOFTWARE_REBOOT: 'SOFTWARE_REBOOT',
  PAYMENT_REBOOT: 'PAYMENT_REBOOT',
  SERVICE_MODE: 'SERVICE_MODE',
  TEST: 'TEST',
  HYBERNATE: 'HIBERNATE',
};

export const HOST_COMMAND_STATUS = {
  ERROR: -99,
  NOT_SUPPORTED: -4,
  RUNTIME_ERROR: -3,
  OVERDUE: -2,
  CANCELED: -1,
  UNKNOWN: 0,
  WAITING: 1,
  ACCEPTED: 2,
  SUCCESS: 3,
};

export const lowDoorKeys = ['DOOR_LOWER_UNKNOWN', 'DOOR_LOWER_OPENED', 'DOOR_LOWER_CLOSED'];
export const upDoorKeys = ['DOOR_UPPER_UNKNOWN', 'DOOR_UPPER_OPENED', 'DOOR_UPPER_CLOSED'];
export const lowLockKeys = ['DOOR_LOCK_LOWER_ERROR', 'DOOR_LOCK_LOWER_UNKNOWN', 'DOOR_LOCK_LOWER_LOCKED', 'DOOR_LOCK_LOWER_UNLOCKED_CLOSED', 'DOOR_LOCK_LOWER_UNLOCKED_OPENED'];
export const upLockKeys = ['DOOR_LOCK_UPPER_ERROR', 'DOOR_LOCK_UPPER_UNKNOWN', 'DOOR_LOCK_UPPER_LOCKED', 'DOOR_LOCK_UPPER_UNLOCKED_CLOSED', 'DOOR_LOCK_UPPER_UNLOCKED_OPENED'];
export const pssKeys = ['PSS_ERROR', 'PSS_UNKNOWN', 'PSS_UNREGISTERED', 'PSS_OK'];
export const printerKeys = ['PS_ERROR', 'PS_PAPER_EMPTY', 'PS_PAPER_LOW', 'PS_UNKNOWN', 'PS_OK'];
export const powerKeys = ['POWER_ERROR', 'POWER_LOW_POWER', 'POWER_UNKNOWN', 'POWER_OK'];
export const paymentKeys = ['PAYMENT_ERROR', 'PAYMENT_UNKNOWN', 'PAYMENT_IDLE', 'PAYMENT_WAIT_CARD', 'PAYMENT_WAIT_BANK', 'PAYMENT_COMPLETE'];

export const lowDoorKeysT = {
  DOOR_LOWER_UNKNOWN: false, DOOR_LOWER_OPENED: false, DOOR_LOWER_CLOSED: false,
};

export const upDoorKeysT = {
  DOOR_UPPER_UNKNOWN: false, DOOR_UPPER_OPENED: false, DOOR_UPPER_CLOSED: false,
};

export const lowLockKeysT = {
  DOOR_LOCK_LOWER_ERROR: false, DOOR_LOCK_LOWER_UNKNOWN: false, DOOR_LOCK_LOWER_LOCKED: false, DOOR_LOCK_LOWER_UNLOCKED_CLOSED: false, DOOR_LOCK_LOWER_UNLOCKED_OPENED: false,
};

export const upLockKeysT = {
  DOOR_LOCK_UPPER_ERROR: false, DOOR_LOCK_UPPER_UNKNOWN: false, DOOR_LOCK_UPPER_LOCKED: false, DOOR_LOCK_UPPER_UNLOCKED_CLOSED: false, DOOR_LOCK_UPPER_UNLOCKED_OPENED: false,
};
export const pssKeysT = {
  PSS_ERROR: false, PSS_UNKNOWN: false, PSS_UNREGISTERED: false, PSS_OK: false,
};
export const printerKeysT = {
  PS_ERROR: false, PS_PAPER_EMPTY: false, PS_PAPER_LOW: false, PS_UNKNOWN: false, PS_OK: false,
};
export const powerKeysT = {
  POWER_ERROR: false, POWER_LOW_POWER: false, POWER_UNKNOWN: false, POWER_OK: false,
};
export const paymentKeysT = {
  PAYMENT_ERROR: false, PAYMENT_UNKNOWN: false, PAYMENT_IDLE: false, PAYMENT_WAIT_CARD: false, PAYMENT_WAIT_BANK: false, PAYMENT_COMPLETE: false,
};
